export const understatedversatile = {
  name: 'Understated & Versatile',
  color: [0.788235294117647, 0.8196078431372549, 0.7843137254901961, 1],
  bg: [0.2, 0.3215686274509804, 0.3215686274509804, 1],
  grid1: [0.6078431372549019, 0.30980392156862746, 0.058823529411764705, 1],
  grid2: [0.17647058823529413, 0.18823529411764706, 0.2, 1],
}
